import { createApp } from 'vue'
import router from '@/router'
import pinia from '@/stores'
import FontAwesome from '@/plugins/fontawesome'
import VueGoogleCharts from 'vue-google-charts'
import '@/styles/index.css'
import App from '@/App.vue'
import { SentryPlugin, MixpanelPlugin } from '@staffingengine/common'

const app = createApp(App)
app.use(router)
app.use(SentryPlugin, router, {
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true' || false,
  debug: import.meta.env.VITE_SENTRY_DEBUG === 'true' || false,
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  release: import.meta.env.VITE_APP_RELEASE || '',
})
app.use(MixpanelPlugin, {
  token: import.meta.env.VITE_MIXPANEL_TOKEN,
  enabled: import.meta.env.VITE_MIXPANEL_ENABLED === 'true' || false,
  debug: import.meta.env.VITE_MIXPANEL_DEBUG === 'true' || false,
  devMode: import.meta.env.DEV,
})
app.use(pinia)
app.use(FontAwesome)
app.use(VueGoogleCharts)

createDatabaseClient()

router.beforeEach(async (to, from) => {
  const client = useDatabaseClient()
  const session = await client.supabase.auth.getSession()

  const isSignedIn = !!session.data?.session
  const isPublic = to.meta.public || false

  const redirectPath = to.fullPath !== '/' ? to.fullPath : undefined

  // Redirect to signin if not authenticated
  if (!isPublic && !isSignedIn) {
    return {
      name: 'auth-signin',
      // save the original route to redirect after sign in
      // TODO: support redirect on sign in page
      query: {
        redirect: redirectPath,
      },
    }
  }
})

app.mount('#app')
